// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderCreateIntegrationApiPayload,
    ProviderCreateIntegrationHl7Payload,
    ProviderCreateIntegrationImportSftpPayload,
    ProviderCreateIntegrationSftpPayload,
    ProviderCreateIntegrationSsoPayload,
    ProviderIntegrationApi,
    ProviderIntegrationHl7,
    ProviderIntegrationImportSftp,
    ProviderIntegrationSftp,
    ProviderIntegrationSortType,
    ProviderIntegrationSso,
    ProviderIntegrationTerminal,
    ProviderIntegrationTerminalToken,
    ProviderIntegrationWebhooks,
    SupportCreateIntegrationApiPayload,
    SupportCreateIntegrationHl7Payload,
    SupportCreateIntegrationImportSftpPayload,
    SupportCreateIntegrationSftpPayload,
    SupportCreateIntegrationSsoPayload,
    SupportIntegrationApi,
    SupportIntegrationHl7,
    SupportIntegrationImportSftp,
    SupportIntegrationSftp,
    SupportIntegrationSortType,
    SupportIntegrationSso,
    SupportIntegrationWebhooks,
    ProviderCreateIntegrationApiPayloadToJSON,
    ProviderCreateIntegrationHl7PayloadToJSON,
    ProviderCreateIntegrationImportSftpPayloadToJSON,
    ProviderCreateIntegrationSftpPayloadToJSON,
    ProviderCreateIntegrationSsoPayloadToJSON,
    SupportCreateIntegrationApiPayloadToJSON,
    SupportCreateIntegrationHl7PayloadToJSON,
    SupportCreateIntegrationImportSftpPayloadToJSON,
    SupportCreateIntegrationSftpPayloadToJSON,
    SupportCreateIntegrationSsoPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderIntegrationApiFromJSON,
    ProviderIntegrationHl7FromJSON,
    ProviderIntegrationImportSftpFromJSON,
    ProviderIntegrationSftpFromJSON,
    ProviderIntegrationSsoFromJSON,
    ProviderIntegrationTerminalFromJSON,
    ProviderIntegrationTerminalTokenFromJSON,
    ProviderIntegrationWebhooksFromJSON,
    SupportIntegrationApiFromJSON,
    SupportIntegrationHl7FromJSON,
    SupportIntegrationImportSftpFromJSON,
    SupportIntegrationSftpFromJSON,
    SupportIntegrationSsoFromJSON,
    SupportIntegrationWebhooksFromJSON,
} from '../models';

export interface DisableProviderApiIntegrationRequest {
    id: string;
}

export interface DisableProviderHl7IntegrationRequest {
    id: string;
}

export interface DisableProviderSftpIntegrationRequest {
    id: string;
}

export interface DisableProviderSftpIntegrationImportRequest {
    id: string;
}

export interface DisableProviderTerminalIntegrationRequest {
    id: string;
}

export interface DisableSupportApiIntegrationRequest {
    id: string;
}

export interface DisableSupportHl7IntegrationRequest {
    id: string;
}

export interface DisableSupportSftpIntegrationRequest {
    id: string;
}

export interface DisableSupportSftpIntegrationImportRequest {
    id: string;
}

export interface GetProviderApiIntegrationRequest {
    id: string;
}

export interface GetProviderHl7IntegrationRequest {
    id: string;
}

export interface GetProviderSftpIntegrationRequest {
    id: string;
}

export interface GetProviderSftpIntegrationImportRequest {
    id: string;
}

export interface GetProviderTerminalIntegrationRequest {
    id: string;
}

export interface GetSupportApiIntegrationRequest {
    id: string;
}

export interface GetSupportHl7IntegrationRequest {
    id: string;
}

export interface GetSupportSftpIntegrationRequest {
    id: string;
}

export interface GetSupportSftpIntegrationImportRequest {
    id: string;
}

export interface ListProviderApiIntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderApiIntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderApplicationSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderApplicationSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderHl7IntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderHl7IntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderIntegrationImportSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderIntegrationImportSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderTerminalIntegrationTokensRequest {
    id: string;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderTerminalIntegrationTokensOrderEnum>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListProviderTerminalIntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderTerminalIntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderIntegrationSortType>;
}

export interface ListSupportApiIntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportApiIntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    sort?: Array<SupportIntegrationSortType>;
}

export interface ListSupportApplicationSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportApplicationSftpOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    sort?: Array<SupportIntegrationSortType>;
}

export interface ListSupportHl7IntegrationsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportHl7IntegrationsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    sort?: Array<SupportIntegrationSortType>;
}

export interface ListSupportIntegrationImportSftpRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportIntegrationImportSftpOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<SupportIntegrationSortType>;
}

export interface PostProviderIntegrationApiRequest {
    providerCreateIntegrationApiPayload: ProviderCreateIntegrationApiPayload;
}

export interface PostProviderIntegrationHl7Request {
    providerCreateIntegrationHl7Payload: ProviderCreateIntegrationHl7Payload;
}

export interface PostProviderIntegrationImportSftpRequest {
    providerCreateIntegrationImportSftpPayload: ProviderCreateIntegrationImportSftpPayload;
}

export interface PostProviderIntegrationSftpRequest {
    providerCreateIntegrationSftpPayload: ProviderCreateIntegrationSftpPayload;
}

export interface PostProviderIntegrationSsoRequest {
    providerCreateIntegrationSsoPayload: ProviderCreateIntegrationSsoPayload;
}

export interface PostSupportIntegrationApiRequest {
    supportCreateIntegrationApiPayload: SupportCreateIntegrationApiPayload;
}

export interface PostSupportIntegrationHl7Request {
    supportCreateIntegrationHl7Payload: SupportCreateIntegrationHl7Payload;
}

export interface PostSupportIntegrationImportSftpRequest {
    supportCreateIntegrationImportSftpPayload: SupportCreateIntegrationImportSftpPayload;
}

export interface PostSupportIntegrationSftpRequest {
    supportCreateIntegrationSftpPayload: SupportCreateIntegrationSftpPayload;
}

export interface PostSupportIntegrationSsoRequest {
    supportCreateIntegrationSsoPayload: SupportCreateIntegrationSsoPayload;
}

/**
 * no description
 */
export class IntegrationApi extends runtime.BaseAPI {

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableProviderApiIntegrationRaw(requestParameters: DisableProviderApiIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableProviderApiIntegration(requestParameters: DisableProviderApiIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableProviderHl7IntegrationRaw(requestParameters: DisableProviderHl7IntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableProviderHl7Integration(requestParameters: DisableProviderHl7IntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableProviderSftpIntegrationRaw(requestParameters: DisableProviderSftpIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableProviderSftpIntegration(requestParameters: DisableProviderSftpIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableProviderSftpIntegrationImportRaw(requestParameters: DisableProviderSftpIntegrationImportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableProviderSftpIntegrationImport(requestParameters: DisableProviderSftpIntegrationImportRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration terminal
     * Disable the integration terminal
     */
    async disableProviderTerminalIntegrationRaw(requestParameters: DisableProviderTerminalIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderTerminalIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration terminal
     * Disable the integration terminal
     */
    async disableProviderTerminalIntegration(requestParameters: DisableProviderTerminalIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderTerminalIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableSupportApiIntegrationRaw(requestParameters: DisableSupportApiIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration API
     * Disable the integration API
     */
    async disableSupportApiIntegration(requestParameters: DisableSupportApiIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableSupportHl7IntegrationRaw(requestParameters: DisableSupportHl7IntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration HL7
     * Disable the integration HL7
     */
    async disableSupportHl7Integration(requestParameters: DisableSupportHl7IntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableSupportSftpIntegrationRaw(requestParameters: DisableSupportSftpIntegrationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration SFTP
     * Disable the integration SFTP
     */
    async disableSupportSftpIntegration(requestParameters: DisableSupportSftpIntegrationRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableSupportSftpIntegrationImportRaw(requestParameters: DisableSupportSftpIntegrationImportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an integration import SFTP server
     * Disable the integration import SFTP server
     */
    async disableSupportSftpIntegrationImport(requestParameters: DisableSupportSftpIntegrationImportRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getProviderApiIntegrationRaw(requestParameters: GetProviderApiIntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationApi>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getProviderApiIntegration(requestParameters: GetProviderApiIntegrationRequest): Promise<ProviderIntegrationApi> {
        const response = await this.getProviderApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getProviderHl7IntegrationRaw(requestParameters: GetProviderHl7IntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationHl7>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getProviderHl7Integration(requestParameters: GetProviderHl7IntegrationRequest): Promise<ProviderIntegrationHl7> {
        const response = await this.getProviderHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getProviderSftpIntegrationRaw(requestParameters: GetProviderSftpIntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getProviderSftpIntegration(requestParameters: GetProviderSftpIntegrationRequest): Promise<ProviderIntegrationSftp> {
        const response = await this.getProviderSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getProviderSftpIntegrationImportRaw(requestParameters: GetProviderSftpIntegrationImportRequest): Promise<runtime.ApiResponse<ProviderIntegrationImportSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getProviderSftpIntegrationImport(requestParameters: GetProviderSftpIntegrationImportRequest): Promise<ProviderIntegrationImportSftp> {
        const response = await this.getProviderSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration terminal
     * Gets an integration terminal id
     */
    async getProviderTerminalIntegrationRaw(requestParameters: GetProviderTerminalIntegrationRequest): Promise<runtime.ApiResponse<ProviderIntegrationTerminal>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderTerminalIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationTerminalFromJSON(jsonValue));
    }

    /**
     * Gets an integration terminal
     * Gets an integration terminal id
     */
    async getProviderTerminalIntegration(requestParameters: GetProviderTerminalIntegrationRequest): Promise<ProviderIntegrationTerminal> {
        const response = await this.getProviderTerminalIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getSupportApiIntegrationRaw(requestParameters: GetSupportApiIntegrationRequest): Promise<runtime.ApiResponse<SupportIntegrationApi>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportApiIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Gets an integration API
     * Gets an integration API id
     */
    async getSupportApiIntegration(requestParameters: GetSupportApiIntegrationRequest): Promise<SupportIntegrationApi> {
        const response = await this.getSupportApiIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getSupportHl7IntegrationRaw(requestParameters: GetSupportHl7IntegrationRequest): Promise<runtime.ApiResponse<SupportIntegrationHl7>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportHl7Integration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Gets an integration HL7
     * Gets an integration HL7 id
     */
    async getSupportHl7Integration(requestParameters: GetSupportHl7IntegrationRequest): Promise<SupportIntegrationHl7> {
        const response = await this.getSupportHl7IntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getSupportSftpIntegrationRaw(requestParameters: GetSupportSftpIntegrationRequest): Promise<runtime.ApiResponse<SupportIntegrationSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSftpIntegration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Gets an integration SFTP
     * Gets an integration SFTP id
     */
    async getSupportSftpIntegration(requestParameters: GetSupportSftpIntegrationRequest): Promise<SupportIntegrationSftp> {
        const response = await this.getSupportSftpIntegrationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getSupportSftpIntegrationImportRaw(requestParameters: GetSupportSftpIntegrationImportRequest): Promise<runtime.ApiResponse<SupportIntegrationImportSftp>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSftpIntegrationImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Gets an sftp server import target
     * Gets an integration sftp server import target id
     */
    async getSupportSftpIntegrationImport(requestParameters: GetSupportSftpIntegrationImportRequest): Promise<SupportIntegrationImportSftp> {
        const response = await this.getSupportSftpIntegrationImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of integration apis
     * Get a list of integration apis
     */
    async listProviderApiIntegrationsRaw(requestParameters: ListProviderApiIntegrationsRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationApi>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationApiFromJSON));
    }

    /**
     * Gets a list of integration apis
     * Get a list of integration apis
     */
    async listProviderApiIntegrations(requestParameters: ListProviderApiIntegrationsRequest): Promise<Array<ProviderIntegrationApi>> {
        const response = await this.listProviderApiIntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listProviderApplicationSftpRaw(requestParameters: ListProviderApplicationSftpRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationSftpFromJSON));
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listProviderApplicationSftp(requestParameters: ListProviderApplicationSftpRequest): Promise<Array<ProviderIntegrationSftp>> {
        const response = await this.listProviderApplicationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listProviderHl7IntegrationsRaw(requestParameters: ListProviderHl7IntegrationsRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationHl7>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationHl7FromJSON));
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listProviderHl7Integrations(requestParameters: ListProviderHl7IntegrationsRequest): Promise<Array<ProviderIntegrationHl7>> {
        const response = await this.listProviderHl7IntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listProviderIntegrationImportSftpRaw(requestParameters: ListProviderIntegrationImportSftpRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationImportSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationImportSftpFromJSON));
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listProviderIntegrationImportSftp(requestParameters: ListProviderIntegrationImportSftpRequest): Promise<Array<ProviderIntegrationImportSftp>> {
        const response = await this.listProviderIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of terminal integration tokens
     * Get a list of terminal integration tokens
     */
    async listProviderTerminalIntegrationTokensRaw(requestParameters: ListProviderTerminalIntegrationTokensRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationTerminalToken>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listProviderTerminalIntegrationTokens.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal/{id}/token`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationTerminalTokenFromJSON));
    }

    /**
     * Gets a list of terminal integration tokens
     * Get a list of terminal integration tokens
     */
    async listProviderTerminalIntegrationTokens(requestParameters: ListProviderTerminalIntegrationTokensRequest): Promise<Array<ProviderIntegrationTerminalToken>> {
        const response = await this.listProviderTerminalIntegrationTokensRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of terminal integrations
     * Get a list of terminal integrations
     */
    async listProviderTerminalIntegrationsRaw(requestParameters: ListProviderTerminalIntegrationsRequest): Promise<runtime.ApiResponse<Array<ProviderIntegrationTerminal>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderIntegrationTerminalFromJSON));
    }

    /**
     * Gets a list of terminal integrations
     * Get a list of terminal integrations
     */
    async listProviderTerminalIntegrations(requestParameters: ListProviderTerminalIntegrationsRequest): Promise<Array<ProviderIntegrationTerminal>> {
        const response = await this.listProviderTerminalIntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of integration APIs
     * Get a list of integration APIs
     */
    async listSupportApiIntegrationsRaw(requestParameters: ListSupportApiIntegrationsRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationApi>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationApiFromJSON));
    }

    /**
     * Gets a list of integration APIs
     * Get a list of integration APIs
     */
    async listSupportApiIntegrations(requestParameters: ListSupportApiIntegrationsRequest): Promise<Array<SupportIntegrationApi>> {
        const response = await this.listSupportApiIntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listSupportApplicationSftpRaw(requestParameters: ListSupportApplicationSftpRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationSftpFromJSON));
    }

    /**
     * Gets a list of sftp integrations
     * Get a list of sftp integrations
     */
    async listSupportApplicationSftp(requestParameters: ListSupportApplicationSftpRequest): Promise<Array<SupportIntegrationSftp>> {
        const response = await this.listSupportApplicationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listSupportHl7IntegrationsRaw(requestParameters: ListSupportHl7IntegrationsRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationHl7>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationHl7FromJSON));
    }

    /**
     * Gets a list of hl7 integrations
     * Get a list of hl7 integrations
     */
    async listSupportHl7Integrations(requestParameters: ListSupportHl7IntegrationsRequest): Promise<Array<SupportIntegrationHl7>> {
        const response = await this.listSupportHl7IntegrationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listSupportIntegrationImportSftpRaw(requestParameters: ListSupportIntegrationImportSftpRequest): Promise<runtime.ApiResponse<Array<SupportIntegrationImportSftp>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportIntegrationImportSftpFromJSON));
    }

    /**
     * Gets a list of sftp server import targets
     * Get a list of sftp server import targets
     */
    async listSupportIntegrationImportSftp(requestParameters: ListSupportIntegrationImportSftpRequest): Promise<Array<SupportIntegrationImportSftp>> {
        const response = await this.listSupportIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create integration api
     * Create an integration api
     */
    async postProviderIntegrationApiRaw(requestParameters: PostProviderIntegrationApiRequest): Promise<runtime.ApiResponse<ProviderIntegrationApi>> {
        if (requestParameters['providerCreateIntegrationApiPayload'] === null || requestParameters['providerCreateIntegrationApiPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationApiPayload','Required parameter requestParameters.providerCreateIntegrationApiPayload was null or undefined when calling postProviderIntegrationApi.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationApiPayloadToJSON(requestParameters['providerCreateIntegrationApiPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Create integration api
     * Create an integration api
     */
    async postProviderIntegrationApi(requestParameters: PostProviderIntegrationApiRequest): Promise<ProviderIntegrationApi> {
        const response = await this.postProviderIntegrationApiRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postProviderIntegrationHl7Raw(requestParameters: PostProviderIntegrationHl7Request): Promise<runtime.ApiResponse<ProviderIntegrationHl7>> {
        if (requestParameters['providerCreateIntegrationHl7Payload'] === null || requestParameters['providerCreateIntegrationHl7Payload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationHl7Payload','Required parameter requestParameters.providerCreateIntegrationHl7Payload was null or undefined when calling postProviderIntegrationHl7.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/hl7`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationHl7PayloadToJSON(requestParameters['providerCreateIntegrationHl7Payload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postProviderIntegrationHl7(requestParameters: PostProviderIntegrationHl7Request): Promise<ProviderIntegrationHl7> {
        const response = await this.postProviderIntegrationHl7Raw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postProviderIntegrationImportSftpRaw(requestParameters: PostProviderIntegrationImportSftpRequest): Promise<runtime.ApiResponse<ProviderIntegrationImportSftp>> {
        if (requestParameters['providerCreateIntegrationImportSftpPayload'] === null || requestParameters['providerCreateIntegrationImportSftpPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationImportSftpPayload','Required parameter requestParameters.providerCreateIntegrationImportSftpPayload was null or undefined when calling postProviderIntegrationImportSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/import/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationImportSftpPayloadToJSON(requestParameters['providerCreateIntegrationImportSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postProviderIntegrationImportSftp(requestParameters: PostProviderIntegrationImportSftpRequest): Promise<ProviderIntegrationImportSftp> {
        const response = await this.postProviderIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postProviderIntegrationSftpRaw(requestParameters: PostProviderIntegrationSftpRequest): Promise<runtime.ApiResponse<ProviderIntegrationSftp>> {
        if (requestParameters['providerCreateIntegrationSftpPayload'] === null || requestParameters['providerCreateIntegrationSftpPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationSftpPayload','Required parameter requestParameters.providerCreateIntegrationSftpPayload was null or undefined when calling postProviderIntegrationSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationSftpPayloadToJSON(requestParameters['providerCreateIntegrationSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postProviderIntegrationSftp(requestParameters: PostProviderIntegrationSftpRequest): Promise<ProviderIntegrationSftp> {
        const response = await this.postProviderIntegrationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an SSO request that generates a URL
     * Create an integration SSOs (single sign on)
     */
    async postProviderIntegrationSsoRaw(requestParameters: PostProviderIntegrationSsoRequest): Promise<runtime.ApiResponse<ProviderIntegrationSso>> {
        if (requestParameters['providerCreateIntegrationSsoPayload'] === null || requestParameters['providerCreateIntegrationSsoPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateIntegrationSsoPayload','Required parameter requestParameters.providerCreateIntegrationSsoPayload was null or undefined when calling postProviderIntegrationSso.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/sso`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateIntegrationSsoPayloadToJSON(requestParameters['providerCreateIntegrationSsoPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationSsoFromJSON(jsonValue));
    }

    /**
     * Create an SSO request that generates a URL
     * Create an integration SSOs (single sign on)
     */
    async postProviderIntegrationSso(requestParameters: PostProviderIntegrationSsoRequest): Promise<ProviderIntegrationSso> {
        const response = await this.postProviderIntegrationSsoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration Terminal
     * Create an integration Terminal
     */
    async postProviderIntegrationTerminalRaw(): Promise<runtime.ApiResponse<ProviderIntegrationTerminal>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/terminal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationTerminalFromJSON(jsonValue));
    }

    /**
     * Create an integration Terminal
     * Create an integration Terminal
     */
    async postProviderIntegrationTerminal(): Promise<ProviderIntegrationTerminal> {
        const response = await this.postProviderIntegrationTerminalRaw();
        return await response.value();
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postProviderIntegrationWebhooksRaw(): Promise<runtime.ApiResponse<ProviderIntegrationWebhooks>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/integration/webhooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderIntegrationWebhooksFromJSON(jsonValue));
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postProviderIntegrationWebhooks(): Promise<ProviderIntegrationWebhooks> {
        const response = await this.postProviderIntegrationWebhooksRaw();
        return await response.value();
    }

    /**
     * Create a professional from a coding
     * Create an integration api
     */
    async postSupportIntegrationApiRaw(requestParameters: PostSupportIntegrationApiRequest): Promise<runtime.ApiResponse<SupportIntegrationApi>> {
        if (requestParameters['supportCreateIntegrationApiPayload'] === null || requestParameters['supportCreateIntegrationApiPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationApiPayload','Required parameter requestParameters.supportCreateIntegrationApiPayload was null or undefined when calling postSupportIntegrationApi.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/api`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationApiPayloadToJSON(requestParameters['supportCreateIntegrationApiPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationApiFromJSON(jsonValue));
    }

    /**
     * Create a professional from a coding
     * Create an integration api
     */
    async postSupportIntegrationApi(requestParameters: PostSupportIntegrationApiRequest): Promise<SupportIntegrationApi> {
        const response = await this.postSupportIntegrationApiRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postSupportIntegrationHl7Raw(requestParameters: PostSupportIntegrationHl7Request): Promise<runtime.ApiResponse<SupportIntegrationHl7>> {
        if (requestParameters['supportCreateIntegrationHl7Payload'] === null || requestParameters['supportCreateIntegrationHl7Payload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationHl7Payload','Required parameter requestParameters.supportCreateIntegrationHl7Payload was null or undefined when calling postSupportIntegrationHl7.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/hl7`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationHl7PayloadToJSON(requestParameters['supportCreateIntegrationHl7Payload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationHl7FromJSON(jsonValue));
    }

    /**
     * Create an integration HL7
     * Create an integration HL7
     */
    async postSupportIntegrationHl7(requestParameters: PostSupportIntegrationHl7Request): Promise<SupportIntegrationHl7> {
        const response = await this.postSupportIntegrationHl7Raw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postSupportIntegrationImportSftpRaw(requestParameters: PostSupportIntegrationImportSftpRequest): Promise<runtime.ApiResponse<SupportIntegrationImportSftp>> {
        if (requestParameters['supportCreateIntegrationImportSftpPayload'] === null || requestParameters['supportCreateIntegrationImportSftpPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationImportSftpPayload','Required parameter requestParameters.supportCreateIntegrationImportSftpPayload was null or undefined when calling postSupportIntegrationImportSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/import/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationImportSftpPayloadToJSON(requestParameters['supportCreateIntegrationImportSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationImportSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration import SFTP server
     * Create an integration import SFTP server
     */
    async postSupportIntegrationImportSftp(requestParameters: PostSupportIntegrationImportSftpRequest): Promise<SupportIntegrationImportSftp> {
        const response = await this.postSupportIntegrationImportSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postSupportIntegrationSftpRaw(requestParameters: PostSupportIntegrationSftpRequest): Promise<runtime.ApiResponse<SupportIntegrationSftp>> {
        if (requestParameters['supportCreateIntegrationSftpPayload'] === null || requestParameters['supportCreateIntegrationSftpPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationSftpPayload','Required parameter requestParameters.supportCreateIntegrationSftpPayload was null or undefined when calling postSupportIntegrationSftp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sftp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationSftpPayloadToJSON(requestParameters['supportCreateIntegrationSftpPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationSftpFromJSON(jsonValue));
    }

    /**
     * Create an integration SFTP
     * Create an integration SFTP
     */
    async postSupportIntegrationSftp(requestParameters: PostSupportIntegrationSftpRequest): Promise<SupportIntegrationSftp> {
        const response = await this.postSupportIntegrationSftpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an SSO request that generates a URL
     * Create an integration SSOs (single sign on)
     */
    async postSupportIntegrationSsoRaw(requestParameters: PostSupportIntegrationSsoRequest): Promise<runtime.ApiResponse<SupportIntegrationSso>> {
        if (requestParameters['supportCreateIntegrationSsoPayload'] === null || requestParameters['supportCreateIntegrationSsoPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateIntegrationSsoPayload','Required parameter requestParameters.supportCreateIntegrationSsoPayload was null or undefined when calling postSupportIntegrationSso.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/sso`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateIntegrationSsoPayloadToJSON(requestParameters['supportCreateIntegrationSsoPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationSsoFromJSON(jsonValue));
    }

    /**
     * Create an SSO request that generates a URL
     * Create an integration SSOs (single sign on)
     */
    async postSupportIntegrationSso(requestParameters: PostSupportIntegrationSsoRequest): Promise<SupportIntegrationSso> {
        const response = await this.postSupportIntegrationSsoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postSupportIntegrationWebhooksRaw(): Promise<runtime.ApiResponse<SupportIntegrationWebhooks>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:integration", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/integration/webhooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportIntegrationWebhooksFromJSON(jsonValue));
    }

    /**
     * Authenticated URL to the webhooks dashboard
     * Authenticated URL to the webhooks dashboard
     */
    async postSupportIntegrationWebhooks(): Promise<SupportIntegrationWebhooks> {
        const response = await this.postSupportIntegrationWebhooksRaw();
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderApiIntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderApplicationSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderHl7IntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderIntegrationImportSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderTerminalIntegrationTokensOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderTerminalIntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportApiIntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportApplicationSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportHl7IntegrationsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportIntegrationImportSftpOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
